export default {
    createYourPassword: 'Create your password',
    newPassword: 'New Password',
    enterNewPassword: 'Enter New Password',
    confirmedPassword: 'Confirmed Password',
    enterConfirmedPassword: 'Enter Confirmed Password',
    login: 'Login',
    newPasswordIsRequired: 'New password is required',
    confirmedPasswordRequired: 'Confirmed password is required',
    passwordIsNotMatch: 'Password is not match'
}
